export class ConnectionsDialogModel {
    type: 'to'|'from'|'cc'|'bcc';
  }